module.exports = __webpack_public_path__ + "static/media/Temperature_mode_RU.93d6c985.pdf";